
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.168.918h1.266v7.367c0 1.521-.378 2.7-1.133 3.54-.755.838-1.857 1.257-3.305 1.257-1.448 0-2.547-.43-3.297-1.289C.944 10.939.566 9.66.566 7.957V.918h1.266v7.07c0 1.365.268 2.373.805 3.024.531.656 1.317.984 2.36.984 1.04 0 1.83-.328 2.366-.984.537-.651.805-1.66.805-3.024V.918z","fill":"currentColor"}})])
          )
        }
      }
    